// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 250px;
  height: 100vh;
  background-color: var(--primary-color);
  color: white;
  transition: width 0.3s;
  padding-top: 20px;
}

.sidebar.collapsed {
  width: 60px;
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

.toggle {
  background-color: #5b1003;
  color: white;
  border: none;
  font-size: 18px;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  transition: 0.3s;

}

.sidebar-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-item {
  display: flex;
  align-items: center;
  padding: 15px;
  cursor: pointer;
  border-bottom: 1px solid #444;
}

.sidebar-item:hover {
  background-color: #5b1003;
}

.sidebar-item.selected {
  background-color: #5b1003;
  /* Highlight selected item */
  color: white;
}

.sidebar-item.selected .sidebar-icon {
  color: white;
}

.sidebar-icon {
  font-size: 20px;
  margin-right: 10px;
}

.sidebar-text {
  display: inline;
  transition: opacity 0.3s;
}

.sidebar-text.hidden {
  display: none;
}

.myflexa-logo {
  height: 30px;
  width: 120px;
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/sidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;;AAElB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;AACd","sourcesContent":[".sidebar {\n  width: 250px;\n  height: 100vh;\n  background-color: var(--primary-color);\n  color: white;\n  transition: width 0.3s;\n  padding-top: 20px;\n}\n\n.sidebar.collapsed {\n  width: 60px;\n}\n\n.sidebar-header {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px;\n}\n\n.toggle {\n  background-color: #5b1003;\n  color: white;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  transition: 0.3s;\n\n}\n\n.sidebar-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.sidebar-item {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  cursor: pointer;\n  border-bottom: 1px solid #444;\n}\n\n.sidebar-item:hover {\n  background-color: #5b1003;\n}\n\n.sidebar-item.selected {\n  background-color: #5b1003;\n  /* Highlight selected item */\n  color: white;\n}\n\n.sidebar-item.selected .sidebar-icon {\n  color: white;\n}\n\n.sidebar-icon {\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n.sidebar-text {\n  display: inline;\n  transition: opacity 0.3s;\n}\n\n.sidebar-text.hidden {\n  display: none;\n}\n\n.myflexa-logo {\n  height: 30px;\n  width: 120px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
